import { render, staticRenderFns } from "./PaymentHeader.vue?vue&type=template&id=fc3075a6&scoped=true&"
import script from "./PaymentHeader.vue?vue&type=script&lang=ts&"
export * from "./PaymentHeader.vue?vue&type=script&lang=ts&"
import style0 from "./PaymentHeader.vue?vue&type=style&index=0&id=fc3075a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc3075a6",
  null
  
)

export default component.exports